import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconSearch } from "../../icons";
import clsx from "clsx";

const Search = ({ onSearch, className, searchPeriod = 1000, suggestions = [], onSuggestionClick, placeholder, defaultValue }: any) => {
  const { t } = useTranslation();
  const textInputRef = useRef<HTMLInputElement>(null);
  const [timeoutId, setTimeoutId] = useState<any>(null);
  const [isFocused, setIsFocused] = useState(false);

  const handleKeyDown = (event: any) => {
    if (event.keyCode === 13) {
      const _text = event.target.value;
      console.log(_text);
    }
  };

  const handleInputChange = (e: any) => {
    const newValue = e.target.value;

    if (searchPeriod === 0) {
      onSearch(newValue);

      return;
    }

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    const newTimeoutId = setTimeout(() => {
      onSearch(newValue);
    }, searchPeriod);

    setTimeoutId(newTimeoutId);
  };

  const handleSuggestionClick = (suggestion: any) => {
    // The BOX shows the label, the CALLER searches `suggestion.value` — see the Trends
    // chips (REF-6218), where the two differ for a renamed chip on purpose.
    if (textInputRef.current) {
      textInputRef.current.value = suggestion.label;
    }

    if (onSuggestionClick) {
      onSuggestionClick(suggestion);
    }
    setIsFocused(false);
  };

  return (
    <div className={clsx("relative w-full", className)}>
      <div className="flex input-container items-center w-full gap-2.5 border border-black-300 rounded-[3px] p-2.5">
        <IconSearch className="w-4 h-4 text-white flex-shrink-0" />
        <input
          ref={textInputRef}
          onKeyDown={handleKeyDown}
          className="input w-full text-white outline-none text-bodySm placeholder-grey"
          placeholder={placeholder ?? t("common:search.placeholder_default")}
          defaultValue={defaultValue}
          onChange={(e) => handleInputChange(e)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setTimeout(() => setIsFocused(false), 200)}
        ></input>
      </div>

      {/* Suggestions dropdown */}
      {isFocused && suggestions.length > 0 && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-black-200 border border-black-300 rounded-[3px] shadow-lg z-50 p-2.5">
          <div className="text-headline text-grey uppercase mb-3">{t("common:search.suggestions_heading")}</div>
          <div className="flex flex-wrap gap-2">
            {suggestions.map((suggestion: any, index: number) => (
              <button
                key={index}
                className="px-[5px] py-[3px] text-h7 text-white bg-black-300 hover:bg-black-100 rounded-[3px] transition-colors flex items-center gap-1"
                onClick={() => handleSuggestionClick(suggestion)}
              >
                {suggestion.label}
                {/* Source badge — only the mixed Trends "All" tab supplies one, and its
                    results are mixed the same way. Every other caller passes chips with
                    no `source` and renders exactly as before. */}
                {suggestion.source && (
                  <span className="text-grey uppercase text-[9px] leading-none">{suggestion.source === "pinterest" ? t("common:search.source_social") : t("common:search.source_runway")}</span>
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Search;
